<!-- Lists all Showcase events for one year, formatted like /Showcases -->

<template>
  <section v-for="showcase in yearShowcases" :key="showcase.link">
    <h4>
      <router-link :to="showcase.link">{{ headingFor(showcase) }}</router-link>
    </h4>
    <router-link v-if="showcase.image" :to="showcase.link">
      <img :src="showcase.image" :alt="`VIZBI Showcase ${showcase.year} hero image`" />
    </router-link>
  </section>
</template>

<script setup>
import showcases, {headingFor} from "@/assets/showcases";
const props = defineProps(["year"]);
const yearShowcases = showcases.filter((showcase) => showcase.year === props.year);
</script>

<style scoped>
section {
  margin-top: 2.5rem;
}
h4 {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}
img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}
</style>
